"use client";

import Button from "../../../../../shared/components/ui/Button";
import useUpdateProgramsSchedule from "../../../../academyProgramDetail/hooks/schedule/useUpdateProgramsSchedule";
import { ProgramScheduleType } from "../../../../../types/dto/program";
import EditProgramScheduleForm from "./EditProgramScheduleForm";
import { formatScheduleMonth } from "../../../../academyProgramDetail/utils/scheduleDateUtils";

export interface EditProgramScheduleProps {
  programSchedule: ProgramScheduleType;
  setOpenModal: (value: boolean) => void;
  onSuccess?: () => void;
}

export default function EditProgramSchedule({
  programSchedule,
  setOpenModal,
  onSuccess,
}: EditProgramScheduleProps) {
  const { control, loading, handleSubmit } = useUpdateProgramsSchedule({
    programSchedule,
    setOpenModal,
    onSuccess,
  });

  return (
    <form onSubmit={handleSubmit}>
      <EditProgramScheduleForm
        control={control}
        collectionMonthLabel={formatScheduleMonth(
          programSchedule.month,
          programSchedule.day_of_month_payment_limit
        )}
      />
      <div className="mt-4 flex items-center justify-end">
        <Button
          primary
          className="bg-[#072082]"
          loading={loading}
          type="submit"
          variant="filled"
        >
          Actualizar
        </Button>
      </div>
    </form>
  );
}
